import React, { useEffect, useState } from "react";
import {
  getBulkDropdownData,
  getOtherRefDetails,
  getOtherRefSearchDropdown,
} from "../../../api/keyvalue";
import SearchDropdown from "../../input/SearchDropdown";
import Button from "../../input/Button";
import Input from "../../input/Input";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { localStorageKeys } from "../../../const";
import { useSelector } from "react-redux";
import Dropdown from "../../input/Dropdown";
import LoadingSpinner from "../../LoadingSpinner";

const ChargeConfirmationSearch = ({
  searchResHandler,
  resetHandler,
  activeAccordion1,
  setActiveAccordion1,
  invStatusPermission,
  evStatusPermission,
}) => {
  const userData = useSelector((state) => state.user.userDetails);
  const user = useSelector((state) => state.user);

  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [jobNos, setJobNos] = useState("");
  const [reqNos, setReqNos] = useState("");

  const [customer, setCustomer] = useState([]);
  const [shipper, setShipper] = useState([]);
  const [transporter, setTransporter] = useState("");
  const [veh, setVeh] = useState([]);

  const [reloadDates, setReloadDates] = useState(true);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [dateType, setDateType] = useState("");
  const [dateTypeOpt, setDateTypeOpt] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState([]);
  const [evInvStatusOpt, setEvInvStatusOpt] = useState(false);
  const [invStatus, setInvStatus] = useState(null);
  const [evStatus, setEvStatus] = useState(null);

  useEffect(() => {
    (async () => {
      setDropdownLoading(true);

      const { date_types: dateTypeData, ev_inv_status: evInvStatus } =
        await getBulkDropdownData([
          { key: "date_types" },
          { key: "ev_inv_status" },
        ]);

      setEvInvStatusOpt(evInvStatus);
      setDateTypeOpt(dateTypeData);
      setDropdownLoading(false);
    })();
  }, []);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      console.log(formattedToday, formattedWeekAgo);
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    setReloadDates(false);
  }, [reloadDates]);

  const onSearch = (e) => {
    e.preventDefault();
    localStorage.removeItem(localStorageKeys.CHARGE_LIST_VIEW);
    searchResHandler({
      dDateType: dateType ? dateType : null,
      dFromDate: fromDate,
      dToDate: toDate,
      sCustomer: customer && customer.length > 0 ? customer.join(",") : "",
      sShipper: shipper && shipper.length > 0 ? shipper.join(",") : "",
      sTransporter: transporter.toString(),
      sJobs: jobNos,
      sRequests: reqNos,
      sVehicle: veh && veh.length > 0 ? veh.join(",") : "",
      invStatus,
      evStatus,
    });
  };

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setVeh([]);
    setDateType("");
    setCustomer([]);
    setShipper([]);
    setTransporter("");
    setReqNos("");
    setJobNos("");
    setReloadDates(true);
    setInvStatus(null);
    setEvStatus(null);
    resetHandler();
  };

  return (
    <>
      <div className="ui styled accordion" style={{ width: "100%" }}>
        <div
          className={`title ${activeAccordion1 ? "active" : ""}`}
          onClick={() => setActiveAccordion1(!activeAccordion1)}
        >
          <div>
            Approval
            <IoCheckmarkCircleOutline
              size={14}
              style={{ marginLeft: "10px" }}
            />
            <i className="dropdown icon"></i>
          </div>
        </div>
        <div className={`content ${activeAccordion1 ? "active" : ""}`}>
          {dropdownLoading ? (
            <LoadingSpinner />
          ) : (
            <form className="ui form">
              <h4 className="ui dividing header">Charge Confirmation Search</h4>
              <div className="three fields">
                <Dropdown
                  // required={true}
                  options={dateTypeOpt}
                  label="Date Type"
                  placeholder="Date Type"
                  style={{ height: "20px" }}
                  value={dateType}
                  onChange={(e, data) => {
                    setDateType(data.value);
                  }}
                  clearable={false}
                />
                <Input
                  label="From Date"
                  type="date"
                  name="fromDate"
                  value={fromDate}
                  onChange={(e) => {
                    setFromDate(e.target.value);
                  }}
                />

                <Input
                  label={"To Date"}
                  type="date"
                  name="toDate"
                  value={toDate}
                  onChange={(e) => {
                    setToDate(e.target.value);
                  }}
                />
              </div>
              <div
                className="four fields"
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) =>
                    setCustomer((prev) => [...prev, data])
                  }
                  occupySpace={false}
                  api={getOtherRefSearchDropdown}
                  apiDependency={
                    userData.type === 1
                      ? {
                          type: "stakeholder_type",
                          value: "Customer",
                        }
                      : {
                          type: "user_stakeholder",
                          value: "Requesting Customer",
                          param2: user.username,
                        }
                  }
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setCustomer((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  label="Customer"
                />
                <SearchDropdown
                  key={1}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) =>
                    setShipper((prev) => [...prev, data])
                  }
                  api={getOtherRefSearchDropdown}
                  occupySpace={false}
                  apiDependency={
                    userData.type === 1
                      ? {
                          type: "stakeholder_type",
                          value: "Shipper",
                          param2: customer.length > 0 ? customer.join(",") : "",
                        }
                      : {
                          type: "user_stakeholder",
                          value: "Shipper",
                          param1: customer.length > 0 ? customer.join(",") : "",
                          param2: user.username,
                        }
                  }
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setShipper((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  label="Shipper"
                />
                <SearchDropdown
                  key={2}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => {
                    setTransporter(data);
                  }}
                  clearable={true}
                  onClear={() => {
                    setTransporter("");
                  }}
                  api={getOtherRefDetails}
                  apiDependency={
                    userData.type === 3
                      ? {
                          type: "user_stakeholder",
                          value: "Transporter",
                          param2: user.username,
                        }
                      : {
                          type: "stakeholder_type",
                          value: "Transporter",
                        }
                  }
                  label="Transporter"
                />
                <SearchDropdown
                  key={1}
                  occupySpace={false}
                  editMode={false}
                  reset={resetSearchFields}
                  setReset={setResetSearchFields}
                  onResultSelect={(data) => setVeh((prev) => [...prev, data])}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "vehicle",
                    value: "",
                  }}
                  multiple={true}
                  multiValueRemoveHandler={(key) => {
                    setVeh((prev) =>
                      prev.filter((item) => item !== parseInt(key)),
                    );
                  }}
                  label="Vehicle"
                />
              </div>

              <div
                className={
                  invStatusPermission && evStatusPermission
                    ? "four fields"
                    : !invStatusPermission && !evStatusPermission
                      ? "two fields"
                      : "three fields"
                }
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div className="field">
                  <label>Job Numbers</label>
                  <input
                    type="text"
                    placeholder="Ex:JOB-0000123"
                    name="jobnos"
                    value={jobNos}
                    onChange={(e) => {
                      setJobNos(e.target.value);
                    }}
                  />
                </div>
                <div className="field">
                  <label>Request Numbers</label>
                  <input
                    type="text"
                    placeholder="Ex:REQ-00000123"
                    name="reqnos"
                    value={reqNos}
                    onChange={(e) => {
                      setReqNos(e.target.value);
                    }}
                  />
                </div>
                {invStatusPermission && (
                  <Dropdown
                    options={evInvStatusOpt}
                    label="Inv Status"
                    placeholder="Inv Status"
                    style={{ height: "20px" }}
                    value={invStatus}
                    onChange={(e, data) => {
                      setInvStatus(data.value);
                    }}
                  />
                )}
                {evStatusPermission && (
                  <Dropdown
                    options={evInvStatusOpt}
                    label="Ev Status"
                    placeholder="Ev Status"
                    style={{ height: "20px" }}
                    value={evStatus}
                    onChange={(e, data) => {
                      setEvStatus(data.value);
                    }}
                  />
                )}
              </div>

              <div className="field">
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  <div className="field" style={{ width: "100%" }}>
                    <Button template="search" onClick={onSearch} />
                    <Button template="searchReset" onClick={onReset} />
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default ChargeConfirmationSearch;
